"use client";

import Picture1 from "../images/top-recommended/petronas-twin-towers.webp";
import Picture2 from "../images/top-recommended/langkawi-cable-car.webp";
import Picture3 from "../images/top-recommended/langkawi-sky-bridge.webp";
import Picture4 from "../images/top-recommended/menara-kuala-lumpur.webp";
import Picture5 from "../images/top-recommended/sunway-lagoon.webp";
import Picture6 from "../images/top-recommended/aquaria-klcc.webp";
import Picture7 from "../images/top-recommended/bako-national-park.webp";
import Picture8 from "../images/top-recommended/lost-world-of-tambun.webp";
import Picture9 from "../images/top-recommended/langkawi-island.webp";
import Picture10 from "../images/top-recommended/batu-caves.webp";
import Picture11 from "../images/top-recommended/mount-kinabalu.webp";
import Picture12 from "../images/top-recommended/semenggoh-nature-reserve.webp";
import Picture13 from "../images/top-recommended/turtle-sanctuary-beach.webp";
import Picture14 from "../images/top-recommended/ling-sen-tong-temple.webp";
import Picture15 from "../images/top-recommended/putrajaya.webp";
import Picture16 from "../images/top-recommended/genting-highlands.webp";
import Picture17 from "../images/top-recommended/chin-swee-temple.webp";
import Picture18 from "../images/top-recommended/merdeka-square.webp";


import PaginationLeft from "@/public/svg/paginarition-arrow-left.svg";
import PaginationRight from "@/public/svg/paginarition-arrow-right.svg";

import Heading from "@/components/heading/heading";

import Image from "next/image";

import "@/styles/common/typo.scss";
import "@/sections/common/top-recommended/top-recommended.scss";

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import { Navigation } from "swiper/modules";

const TopRecommendedList = [
    {
        name: "Petronas Twin Towers",
        picture: Picture1,
        location: "",
    },
    {
        name: "Langkawi Cable Car",
        picture: Picture2,
        location: "",
    },
    {
        name: "Langkawi Sky Bridge",
        picture: Picture3,
        location: "",
    },
    {
        name: "Menara Kuala Lumpur",
        picture: Picture4,
        location: "",
    },
    {
        name: "Sunway Lagoon Theme Park",
        picture: Picture5,
        location: "",
    },
    {
        name: "Aquaria KLCC",
        picture: Picture6,
        location: "",
    },
    {
        name: "Bako National Park",
        picture: Picture7,
        location: "",
    },
    {
        name: "Lost World of Tambun",
        picture: Picture8,
        location: "",
    },
    {
        name: "Langkawi Island",
        picture: Picture9,
        location: "",
    },
    {
        name: "Batu Caves",
        picture: Picture10,
        location: "",
    },
    {
        name: "Mount Kinabalu",
        picture: Picture11,
        location: "",
    },
    {
        name: "Semenggoh Nature Reserve",
        picture: Picture12,
        location: "",
    },
    {
        name: "Turtle Sanctuary Beach",
        picture: Picture13,
        location: "",
    },
    {
        name: "Ling Sen Tong Temple",
        picture: Picture14,
        location: "",
    },
    {
        name: "Putrajaya",
        picture: Picture15,
        location: "",
    },
    {
        name: "Genting Highlands",
        picture: Picture16,
        location: "",
    },
    {
        name: "Chin-Swee Temple",
        picture: Picture17,
        location: "",
    },
    {
        name: "Merdeka Square",
        picture: Picture18,
        location: "",
    },
    
];
const TopRecommended = () => {
    return (
        <section className="top-recommended-section flex items-center py-10 md:py-20 gap-6">
            <div className="top-recommended-info flex flex-col gap-4 container-start">
                <div className="form-title flex flex-col">
                    <Heading as="h3" className="font-yesteryear font-extralight">
                        Top Recommended
                    </Heading>
                    <Heading as="h2" className="text-white">
                        Must Do Things
                    </Heading>
                </div>
                <p className="lead">
                Dive into rich cultures, savor local delicacies, and wander through breathtaking scenery
                </p>
                <div className="swiper-pagination-wrapper flex items-center gap-2 mt-2">
                    <div className="pagination-arrows flex items-center gap-3 sm:gap-4">
                        <figure className="pagination-left-top-recommended flex-center">
                            <Image loading="lazy"
                                src={PaginationLeft}
                                alt="Pagination Left"
                                
                            />
                        </figure>
                        <figure className="pagination-right-top-recommended flex-center">
                            <Image loading="lazy"
                                src={PaginationRight}
                                alt="Pagination Right"
                                
                            />
                        </figure>
                    </div>
                </div>
            </div>
            <div className="top-recommended-slider pl-4">
                <Swiper
                    spaceBetween={16}
                    slidesPerView={1}
                    navigation={{
                        nextEl: ".pagination-right-top-recommended",
                        prevEl: ".pagination-left-top-recommended",
                        enabled: true,
                    }}
                    modules={[Navigation]}
                    breakpoints={{
                        480: {
                            slidesPerView: 2,
                        },
                        767: {
                            slidesPerView: 3,
                        },
                        1023: {
                            slidesPerView: 2,
                        },
                        1279: {
                            slidesPerView: 3,
                        },
                        1535: {
                            slidesPerView: 4,
                        },
                    }}
                    className="top-recommended-swiper"
                >
                    {TopRecommendedList.map((t, index) => {
                        return (
                            <SwiperSlide
                                key={index}
                                className="top-recommended-slide"
                            >
                                <a
                                    
                                    className="inline-flex flex-col gap-6"
                                >
                                    <figure>
                                        <Image loading="lazy"
                                            src={t.picture}
                                            alt={t.name}
                                            
                                        />
                                        <figcaption className="flex flex-col items-start justify-end p-4">
                                            <Heading
                                                as="h6"
                                                className="text-white"
                                            >
                                                {t.name}
                                            </Heading>
                                            <span className="font-light text-white">
                                                {t.location}
                                            </span>
                                        </figcaption>
                                    </figure>
                                </a>
                            </SwiperSlide>
                        );
                    })}
                </Swiper>
            </div>
        </section>
    );
};

export default TopRecommended;
